/**
* @name: msg-detal-win
* @author: weiyong
* @date: 2023-10-08 12:56
* @description：消息详情弹窗（按消息打开配置展示内嵌 iframe）
*   winTemConfig.openType=newDrawer 时以抽屉形态展示，其余弹窗；地址取 pathUrl/pageUrl
* @update: 2026-09-03 支持消息「内容来源」配置：外链/流程表单等按配置弹出，宽高兼容像素值
*/
<template>
  <div  class="msg-detal-win" v-if="dialogVisible">
    <Modal
      v-if="!isDrawer"
      :width="winWidth"
      :maskClosable="false"
      wrapClassName="noPaddingModal"
      :footer="null"
      v-model:visible="dialogVisible"
      :title="winTemConfig.winTitle"
    >
      <div class="win-body"  :style="winBodySty">
          <a-skeleton  v-if="loading" :paragraph="{ rows: 24 }" />
          <iframe class="wh100b" v-show="!loading" @load="loadPage"  :src="iframeUrl"></iframe>
      </div>
    </Modal>
    <Drawer
      v-else
      :width="winWidth"
      class="msgDetailWinDrawer"
      wrapClassName="noPaddingDrawer"
      :visible="dialogVisible"
      @close="dialogVisible = false"
      :title="winTemConfig.winTitle"
    >
      <div class="win-body"  :style="winBodySty">
          <a-skeleton  v-if="loading" :paragraph="{ rows: 24 }" />
          <iframe class="wh100b" v-show="!loading" @load="loadPage"  :src="iframeUrl"></iframe>
      </div>
    </Drawer>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "msg-detal-win",
});
</script>

<script lang="ts" setup>
import {Modal, Drawer} from 'ant-design-vue'
import {useI18n} from "vue-i18n";
import {defineEmits} from "vue";
import {useVModel} from "@vueuse/core";

const { t } = useI18n();

const props:any=defineProps({
  visible:{},
  winTemConfig:{
    type:Object,
    default:function (){
      return {}
    }
  }
})
const {winTemConfig}=toRefs(props);

const emits = defineEmits(['update:visible']);
const dialogVisible = useVModel(props, 'visible', emits);

/**
 * 是否抽屉形态：消息打开配置 openType=newDrawer 时用抽屉，其余弹窗
 */
const isDrawer=computed(()=>{
  return unref(winTemConfig).openType==='newDrawer';
})

/**
 * 内嵌地址：兼容旧配置 pathUrl 与内容来源配置 pageUrl（配置更新后需重新计算，不能只在初始化取一次）
 */
const iframeUrl=computed(()=>{
  const cfg=unref(winTemConfig)||{};
  return cfg.pathUrl||cfg.pageUrl||'';
})

/**
 * 宽度：百分比按视口换算，其余按像素值，未配置默认整屏
 */
const winWidth=computed(()=>{
    const cfgW=unref(winTemConfig).winWidth;
    if(cfgW&&(''+cfgW).indexOf("%")>=0){
      return document.body.clientWidth*(parseFloat(cfgW)/100)+"px";
    }
    if(cfgW!==undefined&&cfgW!==null&&(''+cfgW)!==''){
      return parseFloat(cfgW)+"px";
    }
    return  document.body.clientWidth+"px";
})

/**
 * 高度：抽屉形态内容区自适应滚动，仅弹窗形态生效
 */
const winBodySty=computed(()=>{
  if(unref(isDrawer)){
    return {};
  }
  const sty={};
  const cfgH=unref(winTemConfig).winHeight;
  if(cfgH&&(''+cfgH).indexOf("%")>=0){
    sty["height"] = document.body.clientHeight*(parseFloat(cfgH)/100)+"px";
  }else if(cfgH!==undefined&&cfgH!==null&&(''+cfgH)!==''){
    sty["height"] = parseFloat(cfgH)+"px";
  }else{
    sty["height"] = document.body.clientHeight+"px";
  }
  return sty;
})

const loading=ref(true);
// 重新打开时重置骨架屏，等 iframe load 完成后再展示
watch(()=>props.visible,(newVal)=>{
  if(newVal){
    loading.value=true;
  }
})

const loadPage=function (){
  loading.value=false;
}
</script>

<style type="text/css" lang="less">
.noPaddingModal{
  .ant-modal-body{
    padding: 3px;
  }
}
.noPaddingDrawer{
  .ant-drawer-body{
    padding: 3px;
  }
}
.msg-detal-win .win-body{
  height: 100%;
  overflow: hidden;
}
</style>
